module.exports = __webpack_public_path__ + "static/5-6c64f387db2dad74bbbad011d7c66b5c.png";